export default __webpack_public_path__ + "static/media/wallet.90c94dba.svg";